'use client';

import classnames from 'classnames/bind';
import { useEffect, useRef } from 'react';
import {
  EAnalytics,
  ENumberOfCalls,
  WATCH_OF_INTERSECTING_DELAY,
} from '@/_constants/analytics';
import { watchOfIntersecting } from '@/_utils/watch-of-intersecting';
import { useAnalytics } from '@/_hooks/use-analytics';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'DevelopmentWithWbObserver';

export const DevelopmentWithWbObserver = () => {
  const intersectionTargetRef = useRef<HTMLDivElement | null>(null);
  const sendEvent = useAnalytics();

  useEffect(() => {
    const sendAnalytics = ({ duration }: { duration: number }): void => {
      const config = {
        name: EAnalytics.SUPPLIER_LANDING_ABOUT_WB_V,
        params: { duration },
      };

      sendEvent(config);
    };

    watchOfIntersecting({
      element: intersectionTargetRef.current,
      callback: sendAnalytics,
      delay: WATCH_OF_INTERSECTING_DELAY,
      numberOfCalls: ENumberOfCalls.REGULARLY,
    });
  }, [sendEvent]);

  return <div ref={intersectionTargetRef} className={cn(BLOCK_NAME)} />;
};
